// Accettazione delle Condizioni d'uso alla registrazione (#815).
//
// Chi si registra spunta "Sono maggiorenne, ho letto l'informativa e accetto le
// Condizioni d'uso": qui lo registriamo come prova (art. 7.1 e 5.2 GDPR per
// l'informativa, art. 1341 c.c. per le condizioni), con la versione dei
// documenti in vigore.
//
// Collezione `legalAcceptances`, condivisa con la piattaforma agenzie
// (audience 'agenzia'): regola create-only in newarc-platform/firestore.rules,
// id deterministico `${uid}_utente_t<versione>` così una seconda scrittura
// della stessa accettazione viene rifiutata invece di duplicarsi. Finché la
// regola non è applicata la scrittura fallisce in silenzio, come il registro dei
// cookie (consentManager.js): la registrazione non deve mai dipenderne.
import { db, firebase } from '@/firebase/init';
import { PRIVACY_VERSION, TERMINI_VERSION } from './legalDocuments.js';

export const LEGAL_ACCEPTANCES_COLLECTION = 'legalAcceptances';

// Testo della spunta di registrazione: le parti centrali sono i link.
export const SIGNUP_TERMS_PARTS = Object.freeze({
  before: 'Sono maggiorenne, ho letto l\'',
  privacyLink: 'informativa sulla privacy',
  middle: ' e accetto le ',
  termsLink: 'Condizioni d\'uso',
  after: '.',
});

// Avviso sotto «Accedi con Google» (chi si registra con Google non passa dalla
// spunta).
export const GOOGLE_TERMS_PARTS = Object.freeze({
  before: 'Continuando con Google dichiari di essere maggiorenne, accetti le ',
  termsLink: 'Condizioni d\'uso',
  middle: ' e confermi di aver letto l\'',
  privacyLink: 'informativa sulla privacy',
  after: '.',
});

export function userAcceptanceId(uid) {
  return `${uid}_utente_t${TERMINI_VERSION}`;
}

export function buildUserAcceptance({ uid, context, userAgent = '' }) {
  return {
    uid,
    audience: 'utente',
    documents: { termini: TERMINI_VERSION, privacy: PRIVACY_VERSION },
    context: String(context || 'registrazione').slice(0, 60),
    userAgent: String(userAgent || '').slice(0, 300),
    createdAt: firebase.firestore.FieldValue.serverTimestamp(),
  };
}

// Fire-and-forget: non lancia mai.
export async function recordUserLegalAcceptance({ uid, context }) {
  if (!uid) return false;
  try {
    const userAgent = (typeof window !== 'undefined' && window.navigator && window.navigator.userAgent) || '';
    await db
      .collection(LEGAL_ACCEPTANCES_COLLECTION)
      .doc(userAcceptanceId(uid))
      .set(buildUserAcceptance({ uid, context, userAgent }));
    return true;
  } catch (e) {
    return false;
  }
}
